const React = require('react');
const shallowCompare = require('react-addons-shallow-compare');
const classnames = require('classnames');

module.exports = function (Component) {
  return React.createClass({
    displayName:'DynamicClassHOC',
    propTypes: {
      className: React.PropTypes.string,
      children: React.PropTypes.any,
    },
    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    },
    componentWillUpdate() {
    },
    render() {
      const { className, children, ...props } = this.props;
      const classProps = {};
      let otherProps = {};
      for (let item in props) {
        if (props.hasOwnProperty(item)) {
          if (/^is/.test(item)) {
            const lowerKey = /^is(.*)/.exec(item)[1].toLowerCase();
            classProps[`is-${lowerKey}`] = props[item];
          } else {
            otherProps[item] = props[item];
          }
        }
      }
      const otherPropsWithA = {};
      if (Component === 'a') { // a标签删除
        for (const i in otherProps) {
          if (
            i.indexOf('data-') !== -1 ||
            /^(onTouchTap|onClick|id|class)$/i.test(i)
          ) {
            otherPropsWithA[i] = otherProps[i];
          }
        }
        otherProps = otherPropsWithA;
      }
      return (
        <Component className={classnames(className, classProps)} {...otherProps} >{children}</Component>
        // React.createElement(Component, Object.assign({}, { className:classnames(className, transformedClassProps) }, otherProps), children)
      );
    },
  });
};



// WEBPACK FOOTER //
// ./src/component/mui/misc/dynamic-class-hoc.jsx